import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppRouter } from './router';
import { ThemeProvider } from './lib/theme-context';

// Archivo, self-hosted for the daily bib. The wdth build is the one that
// carries the width axis (font-stretch 62%-125%) the bib's condensed display
// face needs — the default/standard build would silently ignore it.
import '@fontsource-variable/archivo/wdth.css';

import './design-system/global.css';

// Initialize auth listener (side effect)
import './lib/auth-store';

// Stale-client detection (side effect, prod only)
import './lib/update-check';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AppRouter />
    </ThemeProvider>
  </React.StrictMode>,
);
